import { createFileRoute } from "@tanstack/react-router";
import { getCheckins } from "~/fetch/checkins";
import { CardsPage } from "~/components/CardsPage";

export const Route = createFileRoute('/page/$id')({
  component: Component,
  loader: ({ params: { id } }) => {
    return getCheckins({ data: { page: parseInt(id) } })
  },
});

function Component() {
  const data = Route.useLoaderData();
  return <CardsPage data={data} />;
}
